import api from './api';
import { authService } from './authService';

export const tableService = {
  getTables: async (floorId = null) => {
    try {
      const restaurantId = authService.getCurrentRestaurantId();
      let url = `/api/business/tables?restaurant=${restaurantId}`;
      if (floorId) {
        url += `&floorId=${floorId}`;
      }
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error('Error fetching tables:', error);
      throw error;
    }
  },

  addTable: async (tableData) => {
    try {
      const restaurantId = authService.getCurrentRestaurantId();
      
      const formattedData = {
        name: tableData.name.trim(),
        capacity: parseInt(tableData.capacity),
        restaurant: restaurantId,
        selfService: tableData.selfService === true || tableData.selfService === 'true',
        floorId: tableData.floorId || null,
        position: tableData.position || null,
        size: tableData.size || null
      };
      
      const response = await api.post('/api/business/tables', formattedData);
      
      if (!response.data.success) {
        throw new Error(response.data.message || 'Masa eklenirken bir hata oluştu');
      }
      
      return response.data;
    } catch (error) {
      console.error('Error adding table:', error);
      throw error;
    }
  },

  updateTable: async (id, tableData) => {
    try {
      const response = await api.put(`/api/business/tables/${id}`, tableData);
      return response.data;
    } catch (error) {
      console.error('Error updating table:', error);
      throw error;
    }
  },


  deleteTable: async (tableId) => {
    try {
      const response = await api.delete(`/api/business/tables/${tableId}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting table:', error);
      throw error;
    }
  },

  getTableUsageAnalytics: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      if (params.year) queryParams.append('year', params.year);
      if (params.month) queryParams.append('month', params.month);
      
      const response = await api.get(`/api/business/tables/qr-analytics?${queryParams.toString()}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching QR scan analytics:', error);
      throw error;
    }
  },

}; 